import React from "react";
import ReactDOM from "react-dom";
import "./ModalResults.css";

const ModalResults = props => {
  if (!props.isOpen) {
    return false;
  }

  return ReactDOM.createPortal(
    <div className="Modal__overlay">
      <div className="Modal">
        <div className="Modal__header">
          <div className="btn__close__container">
            <div onClick={props.onClose} className="btn__close"></div>
          </div>
        </div>
        <div className="Modal__body">
          <div className="main__container">
            <div className="main__container__validation"></div>
            <div className="main__container__results">
              <div className="main">
                {props.data.candidates.map(candidate => (
                  <div key={candidate.id} className="candidate">
                    <div className="candidate__header">
                      <h2>{candidate.name}</h2>
                    </div>
                    <div className="candidate__body">
                      <img
                        className="candidate__img"
                        src={candidate.img}
                        alt="img Candidato"
                      />
                    </div>
                    <div className="candidate__footer">
                      <h2>{`Votos: ${candidate.voteCount}`}</h2>
                    </div>
                  </div>
                ))}
              </div>
              <div className="main__results">
                <h1>{`Total de votos: ${props.data.totalVotes}`}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("modalResults")
  );
};

export default ModalResults;
